enum ActionTypes {
  GET_ALL_TRANSACTIONS = '@transactions/GET_ALL_TRANSACTIONS',
  GET_ALL_FREEPLAY_CONTRIBUTIONS = '@transactions/GET_ALL_FREEPLAY_CONTRIBUTIONS',
}

export default ActionTypes
